import { pushHistory } from '@jetshop/core/components/Filters/utils/updateHistory';
import qs from 'qs';
export function replaceInSearch({ history, location, queryString, replaceType, routeType }) {
    const { pathname, hash } = location;
    const currentSearch = qs.parse(location.search, { ignoreQueryPrefix: true });
    const parsedString = qs.parse(queryString);
    const [filterType, filterValues] = Object.entries(parsedString)[0];
    const newSearch = Object.assign(Object.assign({}, currentSearch), { [filterType]: replaceType
            ? filterValues
            : Object.assign(Object.assign({}, currentSearch[filterType]), filterValues) });
    if (filterValues === '' && replaceType) {
        delete newSearch[filterType];
    }
    return pushHistory({
        history,
        pathname,
        hash,
        search: newSearch,
        resetPage: true,
        routeType
    });
}
//# sourceMappingURL=replaceInSearch.js.map